module.exports = __webpack_public_path__ + "img/trend-shape-increase-level.6f57a9b5.png";